/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/utils/request';

// 添加工单反馈
export var addFeedback = function addFeedback(param) {
  return request({
    url: 'workOrder/index/addFeedback',
    method: 'post',
    data: param
  });
};

// 获取类型列表
export var getProblemCateList = function getProblemCateList(param) {
  return request({
    url: '/workOrder/index/getProblemCateList',
    method: 'post',
    data: param
  });
};

// export const actionReview = (param) =>
//   request({
//     url: '/workOrder/index/actionReview',
//     method: 'post',
//     data: param
//   })